<template>
<div class="chapter">
<div class="inner_page">
<p class="other"><a id="page_vii"></a><strong>HEGEMONY <span class="small">OR</span> SURVIVAL</strong><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other.vue?4ac7e26d